import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';;
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  constructor(private http: HttpClient) { }

  savereservation(data: any): any {
    return this.http.post(`${API_URL}/reservation`, data, {
      observe: 'response',
    });
  }

  getAllReservtion(page= 0, size= 10): any {
    return this.http.get(`${API_URL}/reservation?page=${page}&size=${size}`);
  }

  searchReservationByCriteria(nomclient: string, contact: string, place: string, voyageNumero: string, page = 0, size = 10): any {
    let url = `${API_URL}/reservation/criteria?page=${page}&size=${size}`;
    if (nomclient) url += `&nomclient=${encodeURIComponent(nomclient)}`;
    if (contact) url += `&contact=${encodeURIComponent(contact)}`;
    if (place) url += `&place=${encodeURIComponent(place)}`;
    if (voyageNumero) url += `&voyageNumero=${encodeURIComponent(voyageNumero)}`;
    return this.http.get(url);
  }

  getCriteriaSearch(criteria: any, page = 0, size = 10, sort = 'creationdate', direction = 'desc'): any {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('direction', direction);
      
    Object.keys(criteria).forEach(key => {
      if (criteria[key] !== null && criteria[key] !== undefined && criteria[key] !== '') {
        params = params.set(key, criteria[key]);
      }
    });

    return this.http.get(`${API_URL}/reservation/criteria`, { params });
  }

}